/* ARUMELA_THEME · theme.js — componentes nativos (Web Components), sin librerías. Cada componente se activa solo si su HTML existe. */
(() => {
  const S1 = window.S1 || { routes: {}, strings: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* almacenamiento no disponible */ } }
  };

  function toast(msg) {
    const t = $('.toast');
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(() => { t.hidden = true; }, 2600);
  }

  function openDialog(d) {
    if (!d || d.open) return;
    d.showModal();
    document.documentElement.style.overflow = 'hidden';
    d.addEventListener('close', () => { document.documentElement.style.overflow = ''; }, { once: true });
  }
  document.addEventListener('click', (e) => {
    const close = e.target.closest('dialog [data-close]');
    if (close) close.closest('dialog').close();
    if (e.target.tagName === 'DIALOG') e.target.close(); /* clic en el fondo */
  });

  /* ---------- reveal al desplazarse ---------- */
  const revealIO = ('IntersectionObserver' in window && !reduced && !document.documentElement.classList.contains('shopify-design-mode'))
    ? new IntersectionObserver((entries) => entries.forEach((en) => {
        /* también si ya quedó por encima (desplazamiento rápido): nunca se queda contenido oculto al volver atrás */
        if (en.isIntersecting || en.boundingClientRect.bottom < 0) { en.target.classList.add('is-revealed'); revealIO.unobserve(en.target); }
      }), { rootMargin: '0px 0px -8% 0px' })
    : null;
  function initReveal(root = document) {
    $$('[data-reveal]', root).forEach((el) => revealIO ? revealIO.observe(el) : el.classList.add('is-revealed'));
  }

  /* ---------- barra de campañas (Q4) ---------- */
  define('announcement-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.dismissed || store.get('abar-' + this.dataset.id) === '1') { this.hidden = true; return; }
      const now = Date.now() / 1000;
      this.slides = $$('[data-slide]', this).filter((s) => {
        const st = parseInt(s.dataset.start || '0', 10), en = parseInt(s.dataset.end || '0', 10);
        const ok = (!st || now >= st) && (!en || now < en);
        if (!ok && !window.Shopify?.designMode) s.remove();
        return ok || window.Shopify?.designMode;
      });
      if (!this.slides.length) { this.hidden = true; return; }
      this.hidden = false;
      this.i = 0; this.show(0);
      if (this.slides.length > 1 && this.dataset.autoplay === 'true' && !reduced) this.play();
      this.addEventListener('mouseenter', () => this.stop()); this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.stop()); this.addEventListener('focusout', () => this.play());
      $('[data-dismiss]', this)?.addEventListener('click', () => { this.hidden = true; store.set('abar-' + this.dataset.id, '1'); });
      document.addEventListener('shopify:block:select', (e) => {
        const idx = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
        if (idx > -1) { this.stop(); this.show(idx); }
      });
    }
    show(n) {
      this.slides.forEach((s, k) => { s.hidden = k !== n; s.classList.toggle('is-in', k === n); });
      this.i = n;
    }
    play() {
      if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || reduced) return;
      this.stop();
      this.t = setInterval(() => this.show((this.i + 1) % this.slides.length), (parseInt(this.dataset.speed, 10) || 6) * 1000);
    }
    stop() { clearInterval(this.t); }
    disconnectedCallback() { this.stop(); }
  });

  define('countdown-timer', class extends HTMLElement {
    connectedCallback() {
      this.end = parseInt(this.dataset.end, 10) * 1000;
      this.els = { d: $('[data-d]', this), h: $('[data-h]', this), m: $('[data-m]', this), s: $('[data-s]', this) };
      this.tick(); this.t = setInterval(() => this.tick(), 1000);
    }
    tick() {
      let left = Math.max(0, this.end - Date.now());
      if (!left) {
        clearInterval(this.t);
        if (this.dataset.expired === 'hide') (this.closest('[data-countdown-scope]') || this).hidden = true;
        return;
      }
      const d = Math.floor(left / 864e5); left -= d * 864e5;
      const h = Math.floor(left / 36e5); left -= h * 36e5;
      const m = Math.floor(left / 6e4); left -= m * 6e4;
      const s = Math.floor(left / 1e3);
      const p = (n) => String(n).padStart(2, '0');
      this.els.d.textContent = p(d); this.els.h.textContent = p(h); this.els.m.textContent = p(m); this.els.s.textContent = p(s);
    }
    disconnectedCallback() { clearInterval(this.t); }
  });

  define('copy-code', class extends HTMLElement {
    connectedCallback() {
      $('button', this)?.addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(this.dataset.code); toast(S1.strings.copied); } catch (e) { /* sin portapapeles */ }
      });
    }
  });

  /* ---------- cabecera ---------- */
  define('sticky-header', class extends HTMLElement {
    connectedCallback() {
      $('[data-open-menu]', this)?.addEventListener('click', () => openDialog($('#MenuDrawer', this)));
      $('[data-open-search]', this)?.addEventListener('click', () => {
        const d = $('[data-search-modal]', this); openDialog(d); $('input[type="search"]', d)?.focus();
      });
      $$('.nav__drop', this).forEach((det) => {
        det.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) det.open = true; });
        det.addEventListener('mouseleave', () => { if (matchMedia('(hover: hover)').matches) det.open = false; });
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.nav__drop[open]', this).forEach((d) => { d.open = false; }); });
      if (this.dataset.glass === 'true') {
        const onY = () => this.classList.toggle('is-scrolled', window.scrollY > 8);
        window.addEventListener('scroll', onY, { passive: true }); onY();
      }
      if (this.dataset.sticky !== 'on-scroll-up') return;
      let last = 0;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        this.classList.toggle('is-hidden', y > last && y > 200);
        last = y;
      }, { passive: true });
    }
  });

  define('predictive-search', class extends HTMLElement {
    connectedCallback() {
      this.input = $('input[type="search"]', this);
      this.results = $('[data-results]', this);
      if (this.dataset.enabled !== 'true' || !this.input) return;
      let h;
      this.input.addEventListener('input', () => { clearTimeout(h); h = setTimeout(() => this.search(), 220); });
    }
    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); return; }
      try {
        const r = await fetch(`${S1.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search`);
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.results.innerHTML = doc.querySelector('.predictive__inner')?.outerHTML || '';
        this.input.setAttribute('aria-expanded', this.results.innerHTML ? 'true' : 'false');
      } catch (e) { /* sin sugerencias */ }
    }
  });

  /* ---------- carrito ---------- */
  async function refreshCart(sectionsHtml) {
    const html = sectionsHtml && sectionsHtml['cart-drawer'];
    const drawerEl = $('cart-drawer');
    if (html && drawerEl) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer]');
      const d = $('[data-cart-drawer]', drawerEl);
      if (fresh && d) {
        d.innerHTML = fresh.innerHTML; d.dataset.count = fresh.dataset.count;
        updateCount(parseInt(fresh.dataset.count, 10));
      }
    } else {
      const cart = await (await fetch(S1.routes.cart + '.js')).json();
      updateCount(cart.item_count);
    }
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach((c) => { c.textContent = n; c.hidden = !n; });
  }
  function openCart() {
    const d = $('[data-cart-drawer]');
    if (d && S1.cartType === 'drawer') openDialog(d); else window.location.href = S1.routes.cart;
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-open-cart]');
    if (a && $('[data-cart-drawer]') && S1.cartType === 'drawer') { e.preventDefault(); openCart(); }
  });

  async function changeLine(key, qty, root) {
    const list = $('.citems', root); list?.classList.add('is-loading');
    const sections = ['cart-drawer'];
    const page = $('[data-cart-page]');
    if (page) sections.push(page.closest('[id^="shopify-section-"]').id.replace('shopify-section-', ''));
    try {
      const r = await fetch(S1.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections })
      });
      const data = await r.json();
      if (data.status) { toast(data.description || S1.strings.error); list?.classList.remove('is-loading'); return; }
      if (page) { window.location.reload(); return; }
      await refreshCart(data.sections);
    } catch (e) { toast(S1.strings.error); list?.classList.remove('is-loading'); }
  }

  define('cart-drawer', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        const inp = e.target.closest('[data-cart-qty]');
        if (inp) changeLine(inp.closest('[data-key]').dataset.key, Math.max(0, parseInt(inp.value, 10) || 0), this);
      });
      this.addEventListener('click', (e) => {
        const rm = e.target.closest('[data-remove]');
        if (rm) { e.preventDefault(); changeLine(rm.closest('[data-key]').dataset.key, 0, this); }
      });
    }
  });
  const cartPage = $('[data-cart-page]');
  if (cartPage) {
    cartPage.addEventListener('change', (e) => {
      const inp = e.target.closest('[data-cart-qty]');
      if (inp) changeLine(inp.closest('[data-key]').dataset.key, Math.max(0, parseInt(inp.value, 10) || 0), cartPage);
    });
    cartPage.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-remove]');
      if (rm) { e.preventDefault(); changeLine(rm.closest('[data-key]').dataset.key, 0, cartPage); }
    });
  }

  define('quantity-input', class extends HTMLElement {
    connectedCallback() {
      this.input = $('input', this);
      $$('[data-step]', this).forEach((b) => b.addEventListener('click', () => {
        const min = parseInt(this.input.min || '0', 10);
        this.input.value = Math.max(min, (parseInt(this.input.value, 10) || 0) + parseInt(b.dataset.step, 10));
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    }
  });

  /* ---------- añadir al carrito (ficha, destacado y tarjetas) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || e.submitter?.name === 'checkout') return;
    if (S1.cartType === 'page' && !$('[data-cart-drawer]')) return; /* envío normal */
    e.preventDefault();
    const btn = e.submitter && e.submitter.type === 'submit' ? e.submitter : $('[type="submit"]', form);
    const err = $('.buy__error', form);
    btn?.classList.add('is-loading'); btn?.setAttribute('aria-disabled', 'true');
    const fd = new FormData(form);
    const qty = form.id ? document.querySelector(`input[name="quantity"][form="${form.id}"]`) : null;
    if (qty) fd.set('quantity', qty.value);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    try {
      const r = await fetch(S1.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await r.json();
      if (data.status) {
        if (err) { err.textContent = data.description || data.message; err.hidden = false; } else toast(data.description || S1.strings.error);
        return;
      }
      if (err) err.hidden = true;
      if (S1.cartType === 'page') { window.location.href = S1.routes.cart; return; }
      await refreshCart(data.sections);
      if (btn && !btn.closest('sticky-buy')) {
        const lbl = $('[data-add-label]', btn);
        btn.classList.add('is-added'); if (lbl) lbl.textContent = S1.strings.added;
        setTimeout(() => { btn.classList.remove('is-added'); if (lbl) lbl.textContent = lbl.dataset.label || S1.strings.addToCart; }, 2200);
      }
      $$('.header__cart').forEach((c) => { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); });
      openCart();
    } catch (x) { toast(S1.strings.error); } finally { btn?.classList.remove('is-loading'); btn?.removeAttribute('aria-disabled'); }
  });

  /* ---------- selector de variantes: la sección se vuelve a pintar con los datos reales de la variante ---------- */
  define('product-info', class extends HTMLElement {
    connectedCallback() {
      const json = $('[data-variants]', this);
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) this.onChange(); });
      this.initSticky();
    }
    selected() {
      const opts = [];
      $$('[data-option-index]', this).forEach((el) => {
        const i = parseInt(el.dataset.optionIndex, 10);
        if (el.tagName === 'SELECT' || el.checked) opts[i] = el.value;
      });
      return opts;
    }
    async onChange() {
      const opts = this.selected();
      const v = this.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('[data-opt-value]', this).forEach((s) => { s.textContent = opts[parseInt(s.dataset.optValue, 10)] || ''; });
      const btn = $('[data-add]', this), label = $('[data-add-label]', this), idInput = $('[data-variant-id]', this);
      if (!v) { if (btn) { btn.disabled = true; label.textContent = S1.strings.unavailable; } return; }
      if (idInput) idInput.value = v.id;
      if (btn) { btn.disabled = !v.available; label.textContent = v.available ? label.dataset.label : S1.strings.soldOut; }
      if (this.dataset.url && !window.Shopify?.designMode && this.closest('.section-main-product')) {
        history.replaceState({}, '', `${this.dataset.url}?variant=${v.id}`);
      }
      if (v.featured_media) document.dispatchEvent(new CustomEvent('s1:variant-media', { detail: { section: this.dataset.section, mediaId: v.featured_media.id } }));
      try {
        const r = await fetch(`${this.dataset.url}?variant=${v.id}&section_id=${this.dataset.section}`);
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const fresh = doc.querySelector('[data-price-wrap]'); const cur = $('[data-price-wrap]', this);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        const fp = doc.querySelector('[data-sticky-price]'); const sp = $('[data-sticky-price]', this);
        if (fp && sp) sp.innerHTML = fp.innerHTML;
      } catch (e) { /* se mantiene el precio anterior */ }
    }
    initSticky() {
      const bar = $('sticky-buy', this); const btn = $('[data-add]', this);
      if (!bar || !btn || !('IntersectionObserver' in window)) return;
      bar.hidden = false;
      /* visible siempre que el botón principal no esté en pantalla (por encima o por debajo): el CTA de compra está a la vista desde el primer momento */
      new IntersectionObserver(([en]) => { bar.classList.toggle('is-visible', !en.isIntersecting); }).observe(btn);
    }
  });

  /* ---------- galería de producto (deslizador, miniaturas, zoom, 3D y RA) ---------- */
  define('product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-track]', this);
      this.slides = $$('.gallery__slide', this);
      this.thumbs = $$('[data-thumb]', this);
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(parseInt(t.dataset.thumb, 10))));
      $('[data-prev]', this)?.addEventListener('click', () => this.go(this.index() - 1));
      $('[data-next]', this)?.addEventListener('click', () => this.go(this.index() + 1));
      this.track?.addEventListener('scroll', () => { clearTimeout(this.h); this.h = setTimeout(() => this.sync(), 80); }, { passive: true });
      document.addEventListener('s1:variant-media', (e) => {
        if (e.detail.section !== this.dataset.section) return;
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(e.detail.mediaId));
        if (i > -1) this.go(i);
      });
      $$('[data-zoom]', this).forEach((b) => b.addEventListener('click', () => this.zoom(b)));
      if ($('[data-model]', this) || $('[data-shopify-xr]', this)) load3D(this);
    }
    index() { return Math.round(this.track.scrollLeft / this.track.clientWidth); }
    go(i) {
      const n = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: n * this.track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      this.mark(n);
    }
    sync() { this.mark(this.index()); }
    mark(n) {
      this.slides.forEach((s, k) => s.setAttribute('aria-hidden', k === n ? 'false' : 'true'));
      this.thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === n); t.toggleAttribute('aria-current', k === n); });
      const c = $('[data-current]', this); if (c) c.textContent = n + 1;
      $$('video', this).forEach((v, k) => { if (!this.slides[n]?.contains(v)) v.pause(); });
    }
    zoom(b) {
      const d = $('[data-lightbox]', this); const img = $('img', b);
      if (!d || !img) return;
      const big = img.cloneNode(); big.removeAttribute('sizes'); big.loading = 'eager';
      big.src = img.currentSrc || img.src; big.srcset = img.srcset;
      $('[data-lightbox-body]', d).replaceChildren(big);
      openDialog(d);
    }
  });

  function load3D(root) {
    if (!window.Shopify?.loadFeatures) return;
    window.Shopify.loadFeatures([
      { name: 'model-viewer-ui', version: '1.0', onLoad: (err) => {
        if (err) return;
        $$('model-viewer', root).forEach((mv) => { if (!mv._ui) { mv._ui = new window.Shopify.ModelViewerUI(mv); } });
      } },
      { name: 'shopify-xr', version: '1.0', onLoad: (err) => {
        if (err) return;
        const data = $('[data-models]', root);
        if (data && window.ShopifyXR) { window.ShopifyXR.addModels(JSON.parse(data.textContent)); window.ShopifyXR.setupXRElements(); }
      } }
    ]);
  }
  define('model-3d-section', class extends HTMLElement {
    connectedCallback() {
      const mv = $('model-viewer', this);
      if (mv && reduced) mv.removeAttribute('auto-rotate');
      load3D(this);
    }
  });

  /* ---------- deslizador genérico (galerías, reseñas, UGC) ---------- */
  define('s1-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-track]', this);
      if (!this.track) return;
      $('[data-prev]', this)?.addEventListener('click', () => this.step(-1));
      $('[data-next]', this)?.addEventListener('click', () => this.step(1));
      if (this.dataset.autoplay === 'true' && !reduced) {
        this.t = setInterval(() => this.step(1, true), (parseInt(this.dataset.speed, 10) || 5) * 1000);
        this.addEventListener('mouseenter', () => clearInterval(this.t));
        this.addEventListener('focusin', () => clearInterval(this.t));
      }
    }
    step(dir, loop) {
      const item = this.track.firstElementChild; if (!item) return;
      const w = item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
      const end = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      if (loop && dir > 0 && end) this.track.scrollTo({ left: 0, behavior: 'smooth' });
      else this.track.scrollBy({ left: dir * w, behavior: reduced ? 'auto' : 'smooth' });
    }
    disconnectedCallback() { clearInterval(this.t); }
  });

  /* ---------- antes / después ---------- */
  define('before-after', class extends HTMLElement {
    connectedCallback() {
      const r = $('input[type="range"]', this);
      const set = () => this.style.setProperty('--pos', r.value + '%');
      r?.addEventListener('input', set); if (r) set();
    }
  });

  /* ---------- vídeo: fachada (el reproductor externo solo se carga al hacer clic) y vídeo nativo ---------- */
  define('video-player', class extends HTMLElement {
    connectedCallback() {
      const play = $('[data-play]', this);
      const tpl = $('template', this);
      play?.addEventListener('click', () => {
        if (tpl) { this.querySelector('[data-poster]')?.remove(); play.remove(); this.append(tpl.content.cloneNode(true)); return; }
        const v = $('video', this); if (v) { play.remove(); v.controls = true; v.play(); }
      });
      const v = $('video[autoplay]', this);
      if (v && reduced) { v.removeAttribute('autoplay'); v.pause(); }
      $('[data-pause]', this)?.addEventListener('click', (e) => {
        const vid = $('video', this); if (!vid) return;
        if (vid.paused) { vid.play(); e.currentTarget.setAttribute('aria-pressed', 'false'); } else { vid.pause(); e.currentTarget.setAttribute('aria-pressed', 'true'); }
      });
    }
  });

  /* ---------- galería visual: zoom a pantalla completa con anterior/siguiente y teclado ---------- */
  define('showcase-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-track]', this);
      this.items = $$('[data-open]', this);
      this.lb = $('[data-lightbox]', this);
      $('[data-prev]', this)?.addEventListener('click', () => this.step(-1));
      $('[data-next]', this)?.addEventListener('click', () => this.step(1));
      this.items.forEach((b, i) => b.addEventListener('click', () => this.show(i)));
      $('[data-lb-prev]', this)?.addEventListener('click', () => this.show(this.i - 1));
      $('[data-lb-next]', this)?.addEventListener('click', () => this.show(this.i + 1));
      this.lb?.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') this.show(this.i - 1); if (e.key === 'ArrowRight') this.show(this.i + 1); });
      if (this.dataset.autoplay === 'true' && !reduced && this.track) {
        this.t = setInterval(() => this.step(1, true), (parseInt(this.dataset.speed, 10) || 5) * 1000);
        ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => clearInterval(this.t), { passive: true }));
      }
    }
    step(dir, loop) {
      const it = this.track?.firstElementChild; if (!it) return;
      const w = it.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 16);
      const end = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      if (loop && end) this.track.scrollTo({ left: 0, behavior: 'smooth' });
      else this.track.scrollBy({ left: dir * w, behavior: reduced ? 'auto' : 'smooth' });
    }
    show(i) {
      if (!this.lb || !this.items.length) return;
      this.i = (i + this.items.length) % this.items.length;
      const b = this.items[this.i]; const src = $('img', b);
      const img = document.createElement('img');
      img.src = b.dataset.full || src?.currentSrc || src?.src; img.alt = src?.alt || '';
      $('[data-lb-body]', this.lb).replaceChildren(img);
      $('[data-lb-cap]', this.lb).textContent = b.closest('figure')?.querySelector('figcaption')?.textContent || '';
      const multi = this.items.length > 1;
      $('[data-lb-prev]', this.lb).hidden = !multi; $('[data-lb-next]', this.lb).hidden = !multi;
      openDialog(this.lb);
    }
    disconnectedCallback() { clearInterval(this.t); }
  });

  /* ---------- vídeo visual: carga solo la fuente del dispositivo (escritorio o móvil) y respeta la reducción de movimiento ---------- */
  define('video-feature', class extends HTMLElement {
    connectedCallback() {
      this.v = $('video', this); this.btn = $('[data-toggle]', this);
      if (!this.v) return;
      const mq = window.matchMedia('(max-width: 749px)');
      const pick = () => (mq.matches ? this.dataset.mob : this.dataset.desk);
      const load = () => {
        const src = pick(); if (!src || this.v.dataset.cur === src) return;
        this.v.dataset.cur = src; this.v.src = src;
        if (this.dataset.autoplay === 'true' && !reduced) this.play();
      };
      this.v.addEventListener('playing', () => this.v.classList.add('is-playing'));
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => {
          if (en.isIntersecting) { load(); if (this.wants && this.v.paused) this.v.play().catch(() => {}); }
          else if (!this.v.paused) { this.v.pause(); this.wants = true; }
        }, { rootMargin: '200px' }).observe(this);
      } else load();
      mq.addEventListener?.('change', load);
      this.btn?.addEventListener('click', () => {
        if (!this.v.src) { this.v.dataset.cur = pick(); this.v.src = pick(); }
        if (this.v.paused) this.play(); else { this.v.pause(); this.wants = false; this.state(true); }
      });
      if (reduced) this.state(true);
    }
    play() { this.v.play().then(() => { this.wants = true; this.state(false); }).catch(() => this.state(true)); }
    state(paused) {
      if (!this.btn) return;
      this.btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      this.btn.setAttribute('aria-label', paused ? this.btn.dataset.labelPlay : this.btn.dataset.labelPause);
    }
  });

  /* ---------- inclinación suave del visual del hero (solo con ratón y sin reducción de movimiento) ---------- */
  if (!reduced && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $$('[data-tilt]').forEach((el) => {
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        el.style.setProperty('--ry', (((e.clientX - r.left) / r.width) - .5) * 8 + 'deg');
        el.style.setProperty('--rx', (.5 - ((e.clientY - r.top) / r.height)) * 6 + 'deg');
      });
      el.addEventListener('pointerleave', () => { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
    });
  }

  /* ---------- varios ---------- */
  document.addEventListener('change', (e) => { if (e.target.matches('[data-autosubmit]')) e.target.form.submit(); });
  $$('[data-cookie-prefs]').forEach((b) => {
    const show = () => window.privacyBanner?.showPreferences?.();
    if (window.privacyBanner) b.hidden = false;
    document.addEventListener('shopify:privacy-banner-loaded', () => { b.hidden = false; });
    b.addEventListener('click', show);
  });
  /* filtros de colección: aplicar al cambiar */
  $$('[data-filter-form]').forEach((f) => f.addEventListener('change', (e) => { if (!e.target.matches('input[type="number"]')) f.requestSubmit(); }));

  initReveal();
  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
})();
